<template>
  <van-tabs v-model="ActiveTab">
    <van-tab title="新申请">
      <span v-show="isShowText" class="h4 show-txt">请在流程设置中，启用流程后使用</span>
      <van-grid class="mt10" :gutter="10" :icon-size="10">
        <van-grid-item v-show="isShowFBForm" text="报销" url="#/account">
          <template #icon>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-shuipiaobaoxiao"></use>
            </svg>
          </template>
        </van-grid-item>
        <van-grid-item v-show="isShowFLForm" text="请假" url="#/takeOff">
          <template #icon>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-shiwuzhongxin_qingjia"></use>
            </svg>
          </template>
        </van-grid-item>
        <van-grid-item v-show="isShowFTForm" text="出差" url="#/business-trip">
          <template #icon>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-jipiao"></use>
            </svg>
          </template>
        </van-grid-item>
        <van-grid-item v-show="isShowFWForm" text="加班" url="#/work-overtime">
          <template #icon>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-jipiao"></use>
            </svg>
          </template>
        </van-grid-item>
        <van-grid-item v-show="!isShowText" text="自定义" url="#/custom-form">
          <template #icon>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconfont-jipiao"></use>
            </svg>
          </template>
        </van-grid-item>
      </van-grid>
    </van-tab>
    <van-tab title="查询">
      <section class="wrapper">
        <aside class="search-panel">
          <van-search v-model="FilterSearch" placeholder="请选择筛选条件" @click="showFilterModal = true" readonly/>
          <van-popup v-model="showFilterModal" round position="bottom">
            <template>
              <div class="row-container mt10">
                <van-field
                  is-link
                  input-align="right"
                  v-model="FormType.text"
                  readonly
                  label="流程名称"
                  placeholder="请选择流程名称"
                  @click="showProcessModel=true"
                />
                <van-field
                  is-link
                  input-align="right"
                  v-model="EmployeeName"
                  label="人员姓名"
                  placeholder="请输入关键字"
                />
                <van-field
                  is-link
                  input-align="right"
                  v-model="SelectedDateRange"
                  readonly
                  label="发起日期"
                  placeholder="请选择日期"
                  @click="shwoStartDateModal=true"
                />
                <van-field
                  is-link
                  input-align="right"
                  v-model="FormState.text"
                  readonly
                  label="审批状态"
                  placeholder="请选择审批状态"
                  @click="showApprovalStateModal=true"
                />
              </div>
              <div class="wc-btn mt10">
                <van-button class="wc-btn-button" type="primary" @click="confirmFilter">确定</van-button>
                <van-button class="ml10 mr10 wc-btn-button" @click="showFilterModal = false">取消</van-button>
              </div>
            </template>
          </van-popup>
          <!--流程名称弹框-->
          <van-popup v-model="showProcessModel" round position="bottom">
            <van-picker
              show-toolbar
              :columns="EnableProcessList"
              @cancel="showProcessModel = false"
              @confirm="(item,index)=>{
              FormType.value=item.value;
              FormType.text=item.text;
              showProcessModel=false;
          }"
            />
          </van-popup>
          <!--日期选择器-->
          <van-popup v-model="shwoStartDateModal" position="bottom">
            <van-datetime-picker
              v-model="CurrentDate"
              title="开始日期"
              type="date"
              :max-date="maxDate"
              @cancel="shwoStartDateModal=false"
              @confirm="()=>{
            minDate=addMinutesHalfAnHourTime(CurrentDate,1440);
            SelectedStartDate = moment(CurrentDate).format('YYYY/MM/DD');
            shwoStartDateModal = false;
            shwoEndDateModal = true;
          }"
            />
          </van-popup>
          <van-popup v-model="shwoEndDateModal" position="bottom">
            <van-datetime-picker
              v-model="CurrentDate"
              title="结束日期"
              type="date"
              :min-date="minDate"
              @cancel="shwoEndDateModal=false"
              @confirm="()=>{
            maxDate=addMinutesHalfAnHourTime(CurrentDate,-1440);
            SelectedEndDate = moment(CurrentDate).format('YYYY/MM/DD');
            SelectedDateRange=SelectedStartDate+'~'+SelectedEndDate;
            shwoEndDateModal = false;
          }"
            />
          </van-popup>
          <!--审批状态弹框-->
          <van-popup v-model="showApprovalStateModal" round position="bottom">
            <van-picker
              show-toolbar
              :columns="ApprovalStateList"
              @cancel="showApprovalStateModal = false"
              @confirm="(item,index)=>{
              FormState.value=item.value;
              FormState.text=item.text;
              showApprovalStateModal=false;
          }"
            />
          </van-popup>
        </aside>
        <aside class="list">
          <ul>
            <li class="approval-item" v-for="(item,i) in paginatedItems" :key="i" @click="selectApprovalItem(item)">
              <div class="date">发起日期：{{item.CreateDate}}</div>
              <van-divider :style="{ borderColor: '#f2f2f2',margin:'1rem' }"/>
              <van-row class="title">
                <van-col span="12">{{formTypeHandle(item.FormType)}}</van-col>
                <van-col span="12" class="text-right">停留时间：<span class="h6 mr5">{{item.State==3?'-':formatMinutes(item.RetentionMin)}}</span></van-col>
              </van-row>
              <div class="summary">单号:{{item.FormNo}}</div>
              <div class="summary">摘要:{{item.Remark}}</div>
              <div class="summary">当前节点:{{item.State===3?"-":item.ApprovalEmployee}}</div>
              <van-divider :style="{ borderColor: '#f2f2f2',margin:'1rem' }" hairline/>
              <div class="user-name">状态:{{formApprovalstate(item.State)}}</div>
            </li>
          </ul>
        </aside>
        <van-pagination v-show="approvalList.length<=pageSize?false:true" v-model="currentPage" :total-items="approvalList.length" :items-per-page="pageSize" @change="onPageChange" />
      </section>
    </van-tab>
  </van-tabs>
</template>

<script>
  import {getFormProcessListApi,getEnableProcessListApi,getMyQueryListApi} from '@/api/reimbursement'
  export default {
    data() {
      return {
        ActiveTab:0,//默认选中的标签
        isShowText:true,//是否显示文字提示
        isShowFBForm:false,//是否显示报销表单
        isShowFLForm:false,//是否显示请假表单
        isShowFTForm:false,//是否显示出差表单
        isShowFWForm:false,//是否显示加班表单
        approvalList: [],//审批列表数据
        pageSize: 10, // 每页显示的条目数
        currentPage: 1, // 当前页码
        showFilterModal: false, // 控制筛选条件弹框的显示与隐藏
        showProcessModel:false,//是否显示流程名称弹框
        shwoStartDateModal:false,//是否显示开始日期弹框
        shwoEndDateModal:false,//是否显示结束日期弹框
        showApprovalStateModal:false,//是否显示审批状态弹框
        EnableProcessList:[],//启用流程列表
        FormType:{text:'全部',value:''},//选择的表单类型
        EmployeeName:'',//员工姓名关键字
        CurrentDate:new Date(),//当前日期
        minDate:new Date((new Date().getFullYear()-10)+"-01-01 00:00"),//最小日期设置为当前时间
        maxDate:new Date((new Date().getFullYear()+10)+"-12-31 23:59"),//最大日期设置为当前时间
        SelectedStartDate:'',//选择的开始日期
        SelectedEndDate:'',//选择的结束日期
        SelectedDateRange:'',//选择的日期范围
        FormState:{text:'全部',value:''},//选择的审批状态
        ApprovalStateList:[
          {value:"",text:"全部"},
          {value:"0",text:"审批中"},
          {value:"2",text:"已拒绝"},
          {value:"3",text:"审批完成"},
          {value:"1",text:"退回修改"}
        ],//审批状态列表
        FilterSearch:''//存储显示的的条件数据
      }
    },
    mounted() {
      this.getFormProcessList();
      this.getEnableProcessList();
      this.getMyQueryList();
      this.selectTab();
    },
    computed: {
      paginatedItems() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.approvalList.slice(start, end);
      }
    },
    methods:{
      //切换标签
      selectTab() {
        let flag=localStorage.getItem("ApproveFlag");
        if(flag!==undefined&&flag!==null&&flag!==""&&flag.length>0){
          this.ActiveTab = parseInt(flag); // 切换到指定的tab索引
          localStorage.removeItem("ApproveFlag");
        }
      },
      //获取流程列表
      async getFormProcessList() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        let response = await getFormProcessListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let dataShowText = true, dataShowFBForm = false, dataShowFLForm = false, dataShowFTForm = false,
              dataShowFWForm = false;//临时变量
            response.result.forEach(function (item, index) {
              switch (item.Process) {
                case "FB":
                  if (item.IsEnable) {
                    dataShowText = false;
                    dataShowFBForm = true;
                  }
                  break;
                case "FL":
                  if (item.IsEnable) {
                    dataShowText = false;
                    dataShowFLForm = true;
                  }
                  break;
                case "FT":
                  if (item.IsEnable) {
                    dataShowText = false;
                    dataShowFTForm = true;
                  }
                  break;
                case "FW":
                  if (item.IsEnable) {
                    dataShowText = false;
                    dataShowFWForm = true;
                  }
                  break;
                default:
                  break;
              }
            });
            this.isShowText = dataShowText;
            this.isShowFBForm = dataShowFBForm;
            this.isShowFLForm = dataShowFLForm;
            this.isShowFTForm = dataShowFTForm;
            this.isShowFWForm = dataShowFWForm;
          }
        }
      },
      //获取启用流程列表
      async getEnableProcessList() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        let response = await getEnableProcessListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            response.result.forEach((item,index)=>{
              let obj=new Object();
              obj.text=item.ProcessName;
              obj.value=item.Process;
              this.EnableProcessList.push(obj);
            });
          }
        }
      },
      //确认筛选提交查询数据
      confirmFilter() {
        this.FilterSearch = (this.FormType.value === undefined || this.FormType.value === null || this.FormType.value === "" || this.FormType.value.length < 1 ? "" : this.FormType.text + ";") +
          (this.EmployeeName === undefined || this.EmployeeName === null || this.EmployeeName === "" || this.EmployeeName.length < 1 ? "" : this.EmployeeName + ";") +
          (this.SelectedDateRange === undefined || this.SelectedDateRange === null || this.SelectedDateRange === "" || this.SelectedDateRange.length < 1 ? "" : this.SelectedDateRange + ";") +
          (this.FormState.value === undefined || this.FormState.value === null || this.FormState.value === "" || this.FormState.value.length < 1 ? "" : this.FormState.text + ";")
        this.FilterSearch = this.FilterSearch.replace(/;$/, '');
        this.getMyQueryList();
        this.showFilterModal = false; // 隐藏弹框并处理筛选逻辑（例如发送请求等）
      },
      //显示审批业务类型
      formTypeHandle(value) {
        let name=value;
        switch (value) {
          case "FK":
            name = "付款申请";
            break;
          case "FC":
            name = "公司信息变更";
            break;
          case "FH":
            name = "员工薪酬表申请";
            break;
          case "FI":
            name = "借款/预付款申请";
            break;
          case "FS":
            name = "销售合同批准";
            break;
          case "FO":
            name = "客户订单确认";
            break;
          case "FA":
            name = "采购合同申请";
            break;
          case "FD":
            name = "采购订单申请";
            break;
          case "FJ":
            name = "组织架构申请";
            break;
          case "FB":
            name = "报销申请";
            break;
          case "FL":
            name = "请假申请";
            break;
          case "FT":
            name = "出差申请";
            break;
          case "FW":
            name = "加班申请";
            break;
          case "发货申请":
            name = "发货申请";
            break;
          case "生产确认":
            name = "生产确认";
            break;
          case "FF":
            name = "入职申请";
            break;
          case "FG":
            name = "离职申请";
            break;
          case "FN":
            name="费用申请";
            break;
          case "FBP":
            name="新增客户";
            break;
          case "FBX":
            name="分配客户";
            break;
          case "HF":
            name="录用申请";
            break;
          case "FZ":
            name="通用申请";
            break;
          default:
            name = value;
            break;
        }
        return name;
      },
      //逗留时间转换格式
      formatMinutes(minutes) {
        let day = parseInt(Math.floor(minutes / 1440));
        let hour = day > 0 ? Math.floor((minutes - day * 1440) / 60) : Math.floor(minutes / 60);
        let minute = Math.floor(minutes - day * 1440 - hour * 60);
        let time = "";
        if (day > 0) time += day + "天";
        if (hour > 0) time += hour + "小时";
        if (minute > 0) time += minute + "分钟";
        return time;
      },
      //审批状态转换格式
      formApprovalstate(value) {
        let formState = "";
        switch (value) {
          case '1':
            formState = "退回修改";
            break;
          case '2':
            formState = "驳回";
            break;
          case '3':
            formState = "审批完成";
            break;
          default:
            formState = "审批中";
            break;
        }
        return formState;
      },
      //获取我经办和我申请审批列表
      async getMyQueryList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          formType: this.FormType.value,
          cGuid: companyInfo.companyId,
          applyUGuid: userInfo.U_GUID,
          employeeName: this.EmployeeName,
          dateBegin:this.SelectedStartDate,
          dateEnd:this.SelectedEndDate,
          state:this.FormState.value
        };
        let response = await getMyQueryListApi(params);
        if (response.success) {
          this.currentPage=1;
          this.approvalList = response.result;
        }
      },
      //更新当前页码到新的页码值
      onPageChange(page) {
        this.currentPage = page;
      },
      //选择待审批数据
      selectApprovalItem(item) {
        localStorage.setItem("ApproveFlag", 1);
        this.$router.push({
          path: '/approval/detail', query: {
            guid: item.Approval_GUID
          }
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    .search-panel {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-items: center;
      margin-top:10px;

      .van-search {
        flex: 1;
      }
    }
    .list {
      overflow-y: auto;
      height: calc(100vh - 18.5rem);
    }
    .van-pagination{
      margin:0 1rem;
    }
  }
  .icon {
    width: 3rem;
    height: 3rem;
  }
  .show-txt{
    display: flex;
    width:100%;
    justify-content: center;
    align-items: center;
    text-align:center;
    color:#31708f;
    height: 5vh;
  }
  .row-container{
    width:100%;
    clear: both;
    overflow: hidden;
  }
  .ml10 {
    margin-left: 10px !important;
  }
  .mr10{
    margin-right: 10px !important;
  }
  .mt10 {
    margin-top: 10px !important;
  }
  .flex-display{
    display: flex;
    display: -webkit-flex;
    align-items: center;
  }
  .col-md-1 {
    width: 10vh;
  }
  .col-md-2 {
    width: calc(100% - 10vh);
  }
  .col-md-right{
    text-align: right;
  }
  .wc-btn {
    width:100%;
    border-top: 1px solid #ccc;
    padding: 10px 0;
    overflow: hidden;
    text-align: right;
  }
  .wc-btn-button{
    height: 30px;
  }
  .approval-item {
    background: white;
    margin: 1rem;
    padding: 1rem;

    .date {
      color: #9c9c9c;
    }

    .title {
      color: #323332;
      font-size: 1.6rem;
    }

    .summary {
      color: #333333;
      margin-top: 1rem;
      font-size: 1.6rem;
    }
    .user-name {
      font-size: 1.6rem;
    }
  }
</style>
